module.exports = __webpack_public_path__ + "img/BlinkArt_Sword2_Green.5613a33e.png";